import { capitalize } from "lodash-es";

import { ColumnId } from "components/DragDropList/types";
import Box from "ds/components/Box";
import Toggle from "ds/components/Toggle";
import Typography from "ds/components/Typography";

import { ActiveFiltersMap, FiltersDictionary } from "../types";

const FiltersSettingModalItemTitle = ({
  id,
  checked,
  onSelect,
  activeFilters,
  dictionary,
}: {
  id: string;
  checked: boolean;
  onSelect: (columnId: ColumnId, id: string, isSelected: boolean) => void;
  activeFilters: ActiveFiltersMap;
  dictionary?: FiltersDictionary;
}) => {
  return (
    <Box justify="between" align="center" grow="1">
      <Box align="center" gap="large">
        <Typography tag="span" variant="p-t7">
          {capitalize(dictionary?.[id] || id)}
        </Typography>
      </Box>
      <Box gap="small" align="center">
        {onSelect && (
          <Toggle
            variant="checkbox"
            tooltip={(isSelected) => {
              if (activeFilters.has(id)) {
                return "This filter is activated and cannot be hidden";
              }

              return isSelected ? "Hide" : "Show";
            }}
            isSelected={checked}
            onChange={(isSelected) => onSelect(ColumnId.First, id, isSelected)}
            isDisabled={activeFilters.has(id)}
          />
        )}
      </Box>
    </Box>
  );
};

export default FiltersSettingModalItemTitle;
